import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "@phosphor-icons/react";

const KEY = "er_cookie_consent";
const SESSION_KEY = "er_session_key";

// Cookie preferences and anonymous session key only — no PII, no auth tokens.
const readLS = (k) => {
  try { return localStorage.getItem(k); } catch (e) { console.warn("[CookieBanner] localStorage read blocked:", e); return null; }
};
const writeLS = (k, v) => {
  try { localStorage.setItem(k, v); } catch (e) { console.warn("[CookieBanner] localStorage write blocked:", e); }
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readLS(KEY)) setVisible(true);

    // Capture UTM once (anonymous, no PII)
    try {
      const url = new URL(window.location.href);
      const utm = {
        source: url.searchParams.get("utm_source"),
        medium: url.searchParams.get("utm_medium"),
        campaign: url.searchParams.get("utm_campaign"),
        content: url.searchParams.get("utm_content"),
        term: url.searchParams.get("utm_term"),
      };
      if (utm.source || utm.campaign) {
        let sk = readLS(SESSION_KEY);
        if (!sk) { sk = "sk_" + Math.random().toString(36).slice(2, 14); writeLS(SESSION_KEY, sk); }
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/acquisition/capture`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...utm, session_key: sk, first_landing_page: window.location.pathname, referrer: document.referrer }),
        }).catch((e) => console.warn("[CookieBanner] acquisition capture failed:", e));
      }
    } catch (e) {
      console.warn("[CookieBanner] UTM capture failed:", e);
    }
  }, []);

  const accept = () => { writeLS(KEY, "accepted"); setVisible(false); };
  const dismiss = () => { writeLS(KEY, "dismissed"); setVisible(false); };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50">
      <div className="border-2 border-foreground bg-white p-4 offset-shadow" data-testid="cookie-banner">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs tracking-widest-2 uppercase font-semibold mb-1">Cookies</div>
            <p className="text-sm">We use essential cookies for authentication and optional cookies for analytics. See our <Link to="/legal/cookies" className="underline">Cookie Policy</Link>.</p>
          </div>
          <button onClick={dismiss} className="text-muted-foreground p-1" data-testid="cookie-close"><X size={16} /></button>
        </div>
        <div className="mt-3 flex gap-2">
          <Button size="sm" onClick={accept} className="rounded-sm" data-testid="cookie-accept">Accept all</Button>
          <Button size="sm" variant="outline" onClick={dismiss} className="rounded-sm" data-testid="cookie-essentials">Essentials only</Button>
        </div>
      </div>
    </div>
  );
}
